import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import useAuthResource from "../resources/useAuthResource";
import { removeUserHandle } from "../utils/localStorageUtils";

const LogoutPopup = ({ setShowPopup }) => {
  const {t} = useTranslation();
  const navigate = useNavigate();
  const { signOut } = useAuthResource();

  const handleLogout = async () => {
    await signOut();
    localStorage.clear();
    removeUserHandle();
    navigate("/");
  };

  return (
    <div
      onClick={() => setShowPopup(false)}
      className="fixed top-0 left-0 bg-bg-grey/80 h-screen w-screen z-50 flex items-center justify-center"
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="w-[90%] h-[200px] relative max-w-[320px] bg-white85 border-div rounded-[10px] p-3 flex flex-col justify-between text-black"
      >
        <div>
          <h1 className="font-bold text-[#000] text-20 text-center">
            {t("logOutQues")}
          </h1>
          <p className="text-10 text-center mt-2">
            {t("logOutDesc")}
          </p>
        </div>

        <div className="mt-7">
          <button
            onClick={handleLogout}
            className="btn-green text-20 bg-sangati-green !text-[#C11E69] border-2 border-black mx-auto mt-3 cursor-pointer"
          >
            {t("logOut")}
          </button>
        </div>
        <div className="absolute -top-4 -translate-y-1/2 left-1/2 -translate-x-1/2" onClick={() => setShowPopup(false)}>
          <img src="/icons/Sangati/cross.svg" alt="" className="scale-120" />
        </div>
      </div>
    </div>
  );
};

export default LogoutPopup;
